<script setup lang="ts">
import { ref } from "vue";
import { v4 as uuidv4 } from "uuid";
import {
	ConditionRule,
	LoadMyWheelsBasePriceRule,
} from "@/modules/rule_engine/ruleEngineClasses";
import ConfigureConditions from "@/modules/rule_engine/components/conditions/ConfigureConditions.vue";
import useDialog from "@/ui/composables/useDialog";
import { parseRule } from "@/modules/rule_engine/parser";
import ConfigureActions from "@/modules/rule_engine/components/ConfigureActions.vue";

const emit = defineEmits(["store"]);

const props = defineProps<{
	rule: LoadMyWheelsBasePriceRule;
}>();

const isDialogVisible = defineModel<boolean>();
const isFormValid = ref<boolean>(false);

// this JSON.. hurts, but because of the class usage spreading doesn't work properly
const loadMyWheelsBasePriceRule = ref<LoadMyWheelsBasePriceRule>(
	parseRule<"load_my_wheels_base_price">(
		JSON.parse(
			JSON.stringify({
				...props.rule,
				type: "load_my_wheels_base_price",
			})
		)
	)
);

const storeLoadMyWheelsBasePriceRule = async () => {
	emit("store", loadMyWheelsBasePriceRule.value);
	isDialogVisible.value = false;
};
</script>

<template>
	<v-dialog v-model="isDialogVisible" persistent width="70vw">
		<v-form v-model="isFormValid">
			<v-card elevation="9" class="help">
				<v-toolbar>
					<v-toolbar-title
						>Configure Load MyWheels Base Price Rule</v-toolbar-title
					>
					<v-spacer></v-spacer>

					<v-btn icon @click="isDialogVisible = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>

				<v-divider />

				<div class="pa-5">
					<div class="pb-5">
						When this component is triggered, <u>all</u> previously applied
						price adjustments are removed and the price is reset to the original
						base price defined by MyWheels.
					</div>
					<configure-conditions
						v-model="loadMyWheelsBasePriceRule.conditions"
					/>
				</div>

				<v-divider class="mt-2" />

				<v-card-actions class="pa-3">
					<v-spacer />
					<v-btn variant="text" color="error" @click="isDialogVisible = false"
						>Cancel</v-btn
					>
					<v-btn
						class="ml-5"
						variant="tonal"
						color="primary"
						@click="storeLoadMyWheelsBasePriceRule"
						>Store Rule</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-dialog>
</template>

<style scoped lang="scss">
.condition {
	border-left: 5px solid #e67e22;
}
</style>
